import { sendNotification } from './sendNotification'

export const catchDeleteNotification = (messageToLog: string) => {
  const text = 'Delete request was failed. Please validate your data correctness'
  sendNotification(text, messageToLog)
}
